import { Box, Typography, Drawer, ListItemButton, ListItemIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

import { drawerWidth, primaryColor } from '../../utils/theme'; // Adjust import path if needed


export const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column', 
  alignItems: 'flex-start', 
  padding: theme.spacing(1, 4), // Compact padding
  width: `${drawerWidth}px`,
  height: '64px', // Reduced height to match Navbar
  backgroundColor: theme.palette.custom.sidebarBg,
  
  // CRITICAL: Fixed positioning to stay above the scrolling navigation list 
  position: 'fixed', 
  top: 0,
  left: 0,
  zIndex: theme.zIndex.drawer,
  
  // Match the border style of the Navbar
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  borderBottom: `1px solid ${theme.palette.grey[300]}`, 
}));

export const LogoText = styled(Typography)({
  fontWeight: 600,
  fontSize: '1rem', // Reduced from 1.2rem
  color: '#333333',
  lineHeight: 1, 
});

export const OrgText = styled(Typography)({
  fontSize: '0.65rem', // Reduced from 0.75rem
  color: '#777', 
  lineHeight: 1,
  marginTop: '2px',
});

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    boxSizing: 'border-box',
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    // CRITICAL: Push the drawer content down below the fixed logo container
    marginTop: '64px', 
    height: 'calc(100% - 64px)', 
  },
}));

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(1, 4), // Consistent with main sidebar
  color: theme.palette.custom.sidebarText,
  minHeight: 40,
  '& .MuiListItemText-primary': {
    fontSize: '0.9rem', // Slightly increased from 0.8rem
    fontWeight: 400,
  },
  '&:hover': {
    backgroundColor: 'transparent', 
  },
  '&.Mui-selected': {
    backgroundColor: 'transparent', 
    '& .MuiListItemText-primary': {
      fontWeight: 600, 
    },
  }
}));

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 32, // Consistent with main sidebar
  color: theme.palette.custom.iconColor, 
  justifyContent: 'center',
  
  '& svg, & img': {
    height: '16px', // Reduced to 16px as requested
    width: '16px',
    color: 'inherit', 
  },
  '& .MuiSvgIcon-root': {
      fontSize: '16px',
      color: theme.palette.grey[500],
  },
}));

export const ChildItem = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(0.5, 3, 0.5, 3.5), 
  color: theme.palette.custom.sidebarText,
  marginLeft: theme.spacing(1), 
  paddingLeft: theme.spacing(7), // Reduced from 8
  width: `calc(100% - ${theme.spacing(1)} * 2)`, 
  
  '& .MuiListItemText-primary': {
    fontSize: '0.875rem', // Slightly increased from 0.8rem
    fontWeight: 400,
  },
  '&:hover': {
    backgroundColor: 'transparent', 
  },
  '&.Mui-selected': {
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    backgroundColor: theme.palette.custom.activeBg,
    borderLeft: `4px solid ${primaryColor} !important`,
    fontWeight: 600,
    position: 'relative',
    paddingLeft: theme.spacing(6.5), 
    '& .MuiListItemText-primary': {
      fontWeight: 600, 
    },
  }
}));

export const ParentListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(1, 3), 
  color: theme.palette.custom.sidebarText,
  borderRadius: '0px',
  
  '&.Mui-selected': {
    backgroundColor: theme.palette.custom.activeBg,
    fontWeight: 600,
    '& .MuiListItemIcon-root': {
        color: theme.palette.custom.sidebarText,
    },
    '&:hover': {
      backgroundColor: theme.palette.custom.activeBg,
    },
  },
  
  '&:hover': {
    backgroundColor: theme.palette.grey[50],
  },
}));